import { useState } from 'react';
import * as api from '../api';
import { FortHillLogo } from './Logo';

export default function LoginPage({ onSuccess }) {
  // Two distinct sign-in flows on a single page, toggled with the tabs below.
  const [mode, setMode] = useState('employee'); // 'employee' | 'admin'
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [emailErr, setEmailErr] = useState('');
  const [busy, setBusy] = useState(false);

  const isAdmin = mode === 'admin';

  const switchMode = (next) => {
    setMode(next);
    setErr('');
    setPassword('');
  };

  const ALLOWED_DOMAINS = ['forthillassociates.com', 'fhlogix.com'];

  const validateEmail = (val) => {
    if (!val) { setEmailErr(''); return; }
    if (!val.includes('@')) { setEmailErr('Enter a valid email address'); return; }
    const domain = val.split('@')[1]?.toLowerCase();
    if (domain && !ALLOWED_DOMAINS.includes(domain)) {
      setEmailErr(`Only ${ALLOWED_DOMAINS.map(d => '@' + d).join(' or ')} emails are allowed`);
    } else {
      setEmailErr('');
    }
  };

  async function onSubmit(e) {
    e.preventDefault();
    setErr('');
    setBusy(true);
    try {
      const { data } = await api.login(email.trim(), isAdmin ? password : undefined);
      localStorage.setItem('fh_token', data.token);
      onSuccess(data.user);
    } catch (ex) {
      setErr(ex.response?.data?.error || 'Login failed');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-wrap">
      <div className="login-box">
        <div className="login-logo"><FortHillLogo width={200} /></div>
        <p className="login-title">Welcome Back</p>
        <p className="login-sub">
          {isAdmin
            ? 'Admin sign-in — enter your credentials'
            : 'Employee sign-in with your organization email'}
        </p>

        <div className="login-tabs" role="tablist" aria-label="Sign in as">
          <button
            type="button"
            role="tab"
            aria-selected={isAdmin}
            className={`login-tab ${isAdmin ? 'active' : ''}`}
            onClick={() => switchMode('admin')}
          >
            Admin
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={!isAdmin}
            className={`login-tab ${!isAdmin ? 'active' : ''}`}
            onClick={() => switchMode('employee')}
          >
            Employee
          </button>
        </div>

        <form onSubmit={onSubmit}>
          <div className="form-group">
            <label className="form-label">Organization Email</label>
            <input
              className={`form-input ${emailErr ? 'error' : ''}`}
              type="email"
              placeholder={isAdmin ? 'admin@forthillassociates.com' : 'yourname@forthillassociates.com'}
              value={email}
              onChange={e => { setEmail(e.target.value); validateEmail(e.target.value); }}
              required
              autoFocus
            />
            {emailErr && (
              <div className="org-badge org-badge-error" style={{ marginTop: 8, marginBottom: 0 }}>
                {emailErr}
              </div>
            )}
          </div>

          {isAdmin && (
            <div className="form-group">
              <label className="form-label">Password</label>
              <input
                className="form-input"
                type="password"
                placeholder="Enter your password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
              />
            </div>
          )}

          {err && <div className="alert">{err}</div>}

          <button
            type="submit"
            disabled={busy || !!emailErr}
            className="btn btn-primary"
            style={{ width: '100%', padding: '11px', marginBottom: 16 }}
          >
            {busy ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}
